
export const resolveOptions = (page = undefined, perpage = undefined, deleted = undefined) => {
    return ['$stateParams', 'optionsService', ($stateParams, optionsService) => {
        if (!$stateParams.filtertext) {
            return optionsService.findAll(page, perpage, deleted).then(list => list);
        }

        return optionsService.search('name', $stateParams.filtertext, page).then(list => list);
    }];
};
export const resolveOption = (param = 'option') => {
    return ['$stateParams', 'optionsService', ($stateParams, optionsService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? optionsService.findById($stateParams[param]) : {};
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/resolvers/options.resolver.js